/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SwitchButtonComponent} from './switch-button.component';
import {FormsModule} from '@angular/forms';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    imports: [CommonModule, FormsModule, TooltipModule],
    declarations: [SwitchButtonComponent],
    exports: [SwitchButtonComponent]
})
export class SwitchButtonModule {
}
